import { ErrorCodeConstants } from '@conf/app.constants';

export type PaymentMethodsType = (typeof PaymentMethodsType)[keyof typeof PaymentMethodsType];
export const PaymentMethodsType = {
  ALIPAY: 'AP',
  UNION_PAY: 'CU',
  CREDIT_CARD: 'CD',
  PAYPAL: 'PP',
} as const;

export interface PaymentTermsPayload {
  paymentMethod: PaymentMethodsType;
}

export const LISTPAYMENTMETHOD = [
  {
    icon: 'assets/images/logo_alipay.svg',
    paymentMethod: PaymentMethodsType.ALIPAY,
    size: {
      width: 88,
      height: 33,
    },
    alt: 'alt.alipay',
    isDisplay: false,
  },
  {
    icon: 'assets/images/logo_unionpay.svg',
    paymentMethod: PaymentMethodsType.UNION_PAY,
    size: {
      width: 55,
      height: 38,
    },
    alt: 'alt.cup',
    isDisplay: false,
  },
  {
    icon: 'assets/images/icon_credit_card_24.svg',
    paymentMethod: PaymentMethodsType.CREDIT_CARD,
    size: {
      width: 24,
      height: 24,
    },
    alt: 'alt.creditCard',
    isDisplay: false,
  },
  {
    icon: 'assets/images/logo_paypal.svg',
    paymentMethod: PaymentMethodsType.PAYPAL,
    size: {
      width: 88,
      height: 33,
    },
    alt: 'alt.paypal',
    isDisplay: false,
  },
];

export const PAYMENT_REQUEST_PAYMENT_CARD_DEFAULT = {
  NEW_CARD: 'newCard',
};

export const EMAIL_DESTINATION = {
  SAME_AS_APPLICATION_COMPLETION_CONTACT_EMAIL_ADDRESS: '0',
  SEND_TO_INDIVIDUAL: '1',
};

export const SMS_DESTINATION = {
  SEND_TO_INDIVIDUAL: '0',
  DO_NOT_SEND: '1',
};

export const CHARGEABLE_LOUNGE_TYPE = {
  ADVANCE_SEAT_RESERVATION: 'SIT-',
  LOUNGE_INFORMATIONL: 'LOUG',
  ADVANCE_ADDITIONAL_BAGGAGE: 'FBAG',
  INFLIGHT_MEAL_INFORMATION: 'MEAL',
};

export const ERROR_MAPPING: Record<string, string> = {
  [ErrorCodeConstants.ERROR_CODES.WBAZ000239]: 'E0521',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000238]: 'W0743',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000241]: 'W0169',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000428]: 'W0736',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000242]: 'E0533',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000564]: 'W0736',
  [ErrorCodeConstants.ERROR_CODES.WBAZ000562]: 'E0422',
};

export const NOTELIGIBLEFORPAYMENT = 'label.notEligibleForPayment';

export const REMOVE_VALIDATIONS_FORMS = [
  'cardNumber',
  'holderName',
  'expiryDate',
  'cvv',
  'cardHolderEmail',
  'cardHolderConfirmEmail',
  'cardHolderPhoneCountry',
  'cardHolderPhoneNumber',
  'issuerReceiptEmail',
  'saveAsBasicReservationInformation',
  'saveAsUsualCheckboxControl',
  'uATPCardChecked',
];
